<template>
  <div
    class="date-row">
    <div>
      <div class="date-row__label">
        {{ $t('Tenders.Date') }}
      </div>
      <DateMenu
        :value="valueMutable.fullDate"
        with_allowed_dates
        @update:value="val => sendValues('date', val)"/>
    </div>
  </div>
</template>
<script>
import DateMenu from 'components/common/inputs/DateMenu.vue'

export default {
  name: 'automationActionDate',
  methods: {
    sendValues(key, props) {
      const result = this.$_.cloneDeep(this.valueMutable)
      result[key] = props

      const resultObject = {
        UpdateDateType: this.value?.UpdateDateType,
        NeedOverrideTime: result.check,
        UpdateValue: `${result.date || ''}T00:00:00`
      }

      this.$emit('update:value', JSON.stringify(resultObject))
    }
  },
  computed: {
    valueMutable() {
      const defaultValue = {
        date: null,
        time: null,
      }
      if (!this.value?.UpdateValue?.trim()) {
        return defaultValue
      }

      const result = this.value?.UpdateValue.split('T')
      if (!result || result.length !== 2) {
        return defaultValue
      }
      return {
        fullDate: this.value?.UpdateValue,
        date: result[0],
        time: result[1],
      }
    }
  },
  components: {
    DateMenu
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
  },
}
</script>
<style scoped lang="scss">
.date-row {
  margin-top: 10px;
  display: grid;
  &__label {
    min-height: 16px;
    margin-bottom: 4px;
    display: flex;
    font-size: 0.75rem;
  }
}

</style>
